import {Part} from '../../models/Part';
import {calculateDurationMs} from '../../business/duration_calculator/calculateDurationMs';

export function calculatePartHeightPx(part: Part): number {
    const durationMillis = calculateDurationMs(part);

    return durationMillis / 1000; //60 pixels per minute
}
